// extracted by mini-css-extract-plugin
export default {"root":"Divisor_root__JGb37","letter":"Divisor_letter__5gTRj"};